
document.addEventListener("DOMContentLoaded", function(){

// !!!!!!! NOW setting up cart total $-based upsells
let tier1 = document.querySelectorAll('.free-samples-tier-1');
let tier2 = document.querySelectorAll('.free-samples-tier-2');
let sampleText1 = "Samples"
let sampleText2 = "Samples"
const sampleLimit = 2;
const dollarMin = 100;
const sampleLimit2 = 1;
const dollarMin2 = 250;
if ( sampleLimit === 1 || sampleLimit === '1' ) {
  sampleText1 = "Sample"
}
if ( sampleLimit2 === 1 || sampleLimit2 === '1' ) {
  sampleText2 = "Sample"
}
//console.log('tier1:::', tier1)

// build html for samples
// also make array of handles for later use
let sampleHandles = [];
let sampleHandles2 = [];
let freeSamplesTier1_html = `<div class="samples_wrap samples_wrap_1"><h2 class="samples_hdr">Select Your Free Samples <span class="subtitle">Your cart has more than $${dollarMin} in it, so you can select ${sampleLimit} free samples!</span></h2><div class="cart_samples">`;

let freeSamplesTier2_html = `<div class="samples_wrap samples_wrap_2"><h2 class="samples_hdr">Your Order Qualifies for Free Samples! <span class="subtitle"></span></h2><div class="cart_samples">`;

if ( tier1.length > 0 ) {
  tier1.forEach(el => {
    sampleHandles.push(el.dataset.sample_handle);
    const title = el.dataset.title;
    const imgPath = el.dataset.img_path;
    const variant_id = el.dataset.variant_id;
    freeSamplesTier1_html += `<article class="free-sample-item">
      <input type="checkbox" name="free_sample" id="free_sample_${variant_id}" data-sample_id="${variant_id}" value="${variant_id}">
      <label for="free_sample_${variant_id}">
        <div class="sample_img"><img src="${imgPath}" alt="${title}"></div>
        <h3>${title}</h3>
      </label>
    </article>`
  });
  freeSamplesTier1_html += `</div><button class="samples_btn_add samples_btn">Add ${sampleText1}</button></div>`;
}


if ( tier2.length > 0 ) {
  tier2.forEach(el => {
    sampleHandles2.push(el.dataset.sample_handle);
    const title = el.dataset.title;
    const imgPath = el.dataset.img_path;
    const variant_id = el.dataset.variant_id;
    freeSamplesTier2_html += `<article class="free-sample-item">
      <input type="checkbox" name="free_sample" id="free_sample_${variant_id}" data-sample_id="${variant_id}" value="${variant_id}">
      <label for="free_sample_${variant_id}">
        <div class="sample_img"><img src="${imgPath}" alt="${title}"></div>
        <h3>${title}</h3>
      </label>
    </article>`
  });
  freeSamplesTier2_html += `</div><button class="samples_btn_add samples_btn2">Add ${sampleText2}</button></div>`;
}


function showFreeSamplesTier1() {

  let cartItemWrap = document.querySelector('#CartContainer .drawer__scrollable');
  //let cartSamples = document.querySelector('.samples_wrap');
  let cartSamples_1 = document.querySelector('.samples_wrap_1');
  let cartSamples_2 = document.querySelector('.samples_wrap_2');
  
  let total = document.querySelector('.drawer__footer .ajaxcart__price');
  if (total) {
    total = total.innerText;
    total = total.replace('$', '');
    total = parseInt(total);
    //console.log('dollarMin and Total', dollarMin, total)
  }
  


  let items = document.querySelectorAll('.ajaxcart__product');
  let sampleProdExists = false;
  let sampleProdExists2 = false;
  let qty = 0;


  if ( items.length > 0 ) {
    console.log(items.length)
    
    items.forEach( el => {
      currentProd = el.dataset.ajaxcarthandle;
      currentTier = el.dataset.tier;
      
      // check if a free sample is in the cart
      if ( sampleHandles.includes(currentProd) ) {
        console.log('it is here!')
        sampleProdExists = true;
        //const num = el.querySelector('.js-qty__num').value;
		

        // get rid of it if the total is now too low
        const addon_item = el.querySelector('.js-qty__num');
        const addon_item_plus = el.querySelector('.js-qty__adjust--plus');
        const addon_qty_wrap = el.querySelector('.js-qty__wrapper');
        if ( dollarMin > total ) {
          addon_item.value = 0;
          console.log('removing something');
          const updateEvent = new Event('change');
          addon_item.dispatchEvent(updateEvent);
        } else {
          // disable qty input
          addon_item.setAttribute("disabled", "");
          addon_item_plus.style.display = 'none';
          addon_qty_wrap.style.width = '75px';
        }
      }

      if ( sampleHandles2.includes(currentProd) ) {
        console.log('it is here!')
        sampleProdExists2 = true;
        //const num = el.querySelector('.js-qty__num').value;
		

        // get rid of it if the total is now too low
        const addon_item = el.querySelector('.js-qty__num');
        const addon_item_plus = el.querySelector('.js-qty__adjust--plus');
        const addon_qty_wrap = el.querySelector('.js-qty__wrapper');
        if ( dollarMin2 > total ) {
          addon_item.value = 0;
          console.log('removing something');
          const updateEvent = new Event('change');
          addon_item.dispatchEvent(updateEvent);
        } else {
          // disable qty input
          addon_item.setAttribute("disabled", "");
          addon_item_plus.style.display = 'none';
          addon_qty_wrap.style.width = '75px';
        }
      }
    }); // END items.forEach
  }


  // check if cart already has samples
  // check if samples are in cart and min amount is no longer met - that's above
  // if samples are in the cart, disable the qty input and set max to 1

  //check if samples is already there, and if it matches the minimum $ amound
  // check for cartSamples because the event listener gets called multiple times, so we don't want to add it to the page multiple time
  // and we don't want to show them if they are already in the cart

  console.log('test: ', cartSamples_1, sampleProdExists,sampleProdExists2, dollarMin, dollarMin2, total)

  if ( !cartSamples_2 && !sampleProdExists2 ) {
    if ( dollarMin2 <= total ) {
      cartItemWrap.insertAdjacentHTML('beforeend', freeSamplesTier2_html)
    } 
  } 
  if ( !cartSamples_1 && !sampleProdExists ) {
    /* dollarMin <= total && dollarMin2 > total */
    if ( dollarMin <= total ) {
      cartItemWrap.insertAdjacentHTML('beforeend', freeSamplesTier1_html)
    }
  }
  

  const samplesBtn = document.querySelector('.samples_btn');
  if (samplesBtn) {
	  samplesBtn.addEventListener('click', function(e) {
      let cartSamples_1 = document.querySelector('.samples_wrap_1');
      addFreeSamples(e, cartSamples_1)
    })
  }
  const samplesBtn2 = document.querySelector('.samples_btn2');
  if (samplesBtn2) {
	  samplesBtn2.addEventListener('click', function(e) {
    let cartSamples_2 = document.querySelector('.samples_wrap_2');
    addFreeSamples(e, cartSamples_2)
  })
  }
  

} // END of showFreeSamplesTier1

function addFreeSamples(e, sampleSelector) {
  e.preventDefault();
  const checkboxValues = []
  var checkboxes = sampleSelector.querySelectorAll('input[name="free_sample"]:checked')
  
  for (var i = 0; i < checkboxes.length; i++) {
    checkboxValues.push(checkboxes[i].value)
  }
  console.log('checkboxValues', checkboxValues)

  let samplesObject = [];
  checkboxValues.forEach( el => {
	  samplesObject.push({"id": el, 'quantity': 1})
  });

  console.log('samplesObject', samplesObject)
  
  let samplesData = {
    'items': samplesObject
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
  },
    body: JSON.stringify(samplesData)
  })
  .then(response => {
    /* document.dispatchEvent(new CustomEvent('addedItems', {
		detail: {
			cart: cart
		}
	}));
	//added.ajaxProduct */
    $('body').trigger('added.ajaxProduct');
	  return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}


function checkboxlimit(checkgroup, limit){
	for (var i=0; i<checkgroup.length; i++){
		checkgroup[i].onclick=function(){
		var checkedcount=0
		for (var i=0; i<checkgroup.length; i++)
			checkedcount+=(checkgroup[i].checked)? 1 : 0
		if (checkedcount>limit){
			alert("You can only select a maximum of "+limit+" samples")
			this.checked=false
			}
		}
	}
}
document.addEventListener('input', function(e) {
  if ( !e.target.matches('[name="free_sample"]') ) return;
  if ( e.target.closest('.samples_wrap_1')) {
    let cartSamples_1 = document.querySelector('.samples_wrap_1');
    let theInputs = cartSamples_1.querySelectorAll('[name="free_sample"]');
    checkboxlimit(theInputs, sampleLimit)
  }
  if ( e.target.closest('.samples_wrap_2')) {
    let cartSamples_2 = document.querySelector('.samples_wrap_2');
    let theInputs = cartSamples_2.querySelectorAll('[name="free_sample"]');
    checkboxlimit(theInputs, sampleLimit2)
  }
  
})


// Mutation Observer to check if the cart is open
const thePage2 = document.querySelector('html')
//const theCart = document.querySelector('#CartContainer')
const options2 = {
  attributes: true
}

function callback2(mutationList, observer) {
  mutationList.forEach(function(mutation) {
    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
      if ( thePage2.classList.contains('js-drawer-open') ) {
        console.log('it is open')
        
        //$-based sample offers
        showFreeSamplesTier1();
      } else {
        console.log('it is closed')
      }
    }
  })
}


function removeSampleLinks2() {
  let items = document.querySelectorAll('.ajaxcart__product');

  items.forEach( el => {
    currentProd = el.dataset.ajaxcarthandle;
    
    // check if a product that triggers the free Dry Powder sample is in the cart
    if ( currentProd.includes('-sample') ) {
      console.log('sample!')
      let el_links = el.querySelectorAll('a');
      el_links.forEach(el => {
        el.href= '';
        el.style.cursor = 'default';
        el.addEventListener('click', function(e) {
          el.preventDefault();
        })
      })
    }
  });
}

const observer2 = new MutationObserver(callback2)
observer2.observe(thePage2, options2)
// END Mutation Observer to check if the cart is open
const observerUpdate2 = new MutationObserver(callback2)


// listen for buildcart function - among other times, it is triggered when the quantity is changed
// this is used for all free sample offers
document.addEventListener('cart:updated', function(evt) {
  console.log(evt.detail.cart);
  console.log('cart build happened')

  showFreeSamplesTier1();
  removeSampleLinks2();
});

}); //end document loaded
